const STORAGE_KEY = 'time_offset';

let timeOffset = (() => {
  try {
    return parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10) || 0;
  } catch (e) {
    return 0;
  }
})();

/**
 * Parse the Date response header and update the clock offset.
 * Uses the current local time as t2 (response-received moment).
 */
export function syncTimeFromServerDate(dateHeaderStr) {
  const serverTime = new Date(dateHeaderStr).getTime();
  if (isNaN(serverTime)) return;
  timeOffset = serverTime - Date.now();
  try {
    localStorage.setItem(STORAGE_KEY, String(timeOffset));
  } catch (e) {
    // localStorage unavailable — ignore
  }
  console.log(`[TimeSync] Offset updated: ${timeOffset}ms`);
}

export function getSyncedTime() {
  return Date.now() + timeOffset;
}

export function getSyncedDate() {
  return new Date(getSyncedTime());
}

/**
 * Proactively sync time by making a HEAD request to the backend.
 * Uses (t1 + t2) / 2 midpoint for latency compensation.
 * Falls back to local time if the request fails.
 */
export async function initTimeSync(baseUrl) {
  try {
    const t1 = Date.now();
    const res = await fetch(baseUrl, { method: 'HEAD' });
    const dateHeader = res.headers.get('date');
    if (dateHeader) {
      const t2 = Date.now();
      const serverTime = new Date(dateHeader).getTime();
      if (!isNaN(serverTime)) {
        timeOffset = serverTime - Math.round((t1 + t2) / 2);
        try {
          localStorage.setItem(STORAGE_KEY, String(timeOffset));
        } catch (e) {
          // ignore
        }
        console.log(`[TimeSync] Offset from HEAD request: ${timeOffset}ms`);
      }
    }
  } catch (e) {
    console.warn('[TimeSync] Sync failed, using local time:', e.message);
  }
}
